<template>
      <div class="section section-pricing-2">
          <div class="md-layout text-center">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <h2 class="title">
                Conoce Nuestro Precios
              </h2>
            </div>
          </div>
        <div class="container">
          
           <div class="md-layout">
             
            <div  class="md-layout-item md-size-25 md-small-size-100" >
              <pricing-card card-plain>
                <template slot="cardContent">
                  <h3 class="card-category text-info">
                    Temporada <br> Baja
                  </h3>
                  <h1 class="card-title">
                    <small>$</small>1,800
                  </h1>
                  <ul>
                    <li><b>POR NOCHE</b></li>
                    <li> Lunes a Jueves</li>
                  </ul>
                </template>
              </pricing-card>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <pricing-card card-bg="info">
                <template slot="cardContent">
                  <h3 class="card-category">
                    Fin de <br> Semana
                  </h3>
                  <h1 class="card-title">
                    <small>$</small>2,000
                  </h1>
                  <ul>
                    <li><b>POR NOCHE </b></li>
                    <li>Viernes a Domingo</li>
                  </ul>
                </template>
              </pricing-card>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <pricing-card card-plain>
                <template slot="cardContent">
                  <h3 class="card-category text-info">
                    Temporada <br> Alta
                  </h3>
                  <h1 class="card-title">
                    <small>$</small>2,000
                  </h1>
                  <ul>
                    <li><b>POR NOCHE</b></li>
                    <li> Lunes a Domingo</li>
                  </ul>

                </template>
              </pricing-card>
            </div>
               <div class="md-layout-item md-size-25 md-small-size-100">
              <pricing-card card-plain>
                <template slot="cardContent">
                  <h3 class="card-category text-info">
                    Beneficios de tu Reserva 
                  </h3>
                  <ul>
                    <li><b>Reservación Segura</b></li>
                     <li><b>Mejor Tarifa Garantizada</b></li>
                    <li><b>Sin Cuota para Reservar</b></li>
                    <li><b>Cancelación sin costo</b></li>
                  </ul>

                </template>
              </pricing-card>
            </div>
          </div>
           </div>
            </div>
              
</template>

<script>
import { PricingCard, } from "@/components";
import Mixins from "@/plugins/basicMixins";
export default {
  components: {
    PricingCard,  },
  mixins: [Mixins.HeaderImage],
  data() {
    return {
      image: require("@/assets/img/examples/bg-pricing.jpg")
    };
  }
};
</script>

<style lang="scss"></style>
